import { ChipStatus } from 'framework/chip';
import { CHIP_VARIANT } from 'framework/chip/enums';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';

import cn from './Cell.module.scss';

export const GridPriceChipCell = <T extends Record<string, any>>() => {
  const { row } = useGridRowContext<T>();
  const { column } = useGridColumnContext();
  const label = row.price_change_pct_formatted || '';
  const sign = Math.sign(row.price_change_pct || 0);
  const variant = sign === 1 ? CHIP_VARIANT.GREEN : CHIP_VARIANT.RED;
  return (
    <div className={cn.cell} style={{ justifyContent: column.text_align }}>
      <ChipStatus label={label} variant={variant} width="100%" />
    </div>
  );
};
